import { render, staticRenderFns } from "./viewer.vue?vue&type=template&id=31f5f177&scoped=true&"
import script from "./viewer.vue?vue&type=script&lang=js&"
export * from "./viewer.vue?vue&type=script&lang=js&"
import style0 from "./viewer.vue?vue&type=style&index=0&id=31f5f177&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f5f177",
  null
  
)

export default component.exports